// Is a given value equal to null?
export default function isNull(obj) {
  return obj === null;
}



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/isNull.js
// module id = 1581
// module chunks = 106